import { useMutation } from '@tanstack/react-query';
import { ApiResponseError } from '../../../../types/errors';
import { useAccountApi } from '../../hooks/use-settings-api';
import type { ConfirmTwoFactorApiRequest } from '../../types';
import { TwoFactorError } from '../errors';

export function useConfirmTwoFactor() {
  const { accountApi } = useAccountApi();

  async function confirmTwoFactor(data: ConfirmTwoFactorApiRequest) {
    try {
      await accountApi.confirmTwoFactor(data);
    } catch (err) {
      if (
        ApiResponseError.isApiResponseError(err, ApiResponseError.errorSchemas.message) &&
        err.status === 422
      ) {
        throw new TwoFactorError('invalid_code');
      }

      throw err;
    }
  }

  return useMutation({
    mutationFn: confirmTwoFactor,
  });
}
